"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _coreSc = require("@smooth-ui/core-sc");

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var NavWrapper = (0, _coreSc.styled)(_Wrapper["default"]).withConfig({
  displayName: "NavWrapper",
  componentId: "sc-1d0gp9e-0"
})(["display:flex;align-items:center;justify-content:space-between;", ""], (0, _coreSc.up)('md', (0, _coreSc.css)(["justify-content:flex-start;"])));
var _default = NavWrapper;
exports["default"] = _default;